// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"5a2a3b3d","821":"dc85bcf7"}[chunkId] + ".chunk.js";
};